import React, { useRef, useEffect, useContext } from "react";
import PsContext from "../../context";

const YouTubeVideo = ({ videoId }) => {
  const context = useContext(PsContext);
  return (
    <iframe
      width="100%"
      height={context.windowSize > 700 ? "500px" : "auto"}
      src={`${videoId}?autoplay=1&mute=1&rel=0&enablejsapi=1&loop=1&showinfo=0&controls=0`}
      allow="autoplay"
      frameborder="0"
    ></iframe>
  );
};
/*
const YouTubeVideo = ({ videoId }) => {
  const playerRef = useRef(null); // Ref to hold the player container

  useEffect(() => {
    // Function to initialize the YouTube player
    const initializePlayer = () => {
      if (playerRef.current && window.YT) {
        new window.YT.Player(playerRef.current, {
          height: "360",
          width: "640",
          videoId: videoId,
          playerVars: {
            autoplay: 1, // Automatically start the video
            controls: 1, // Show video controls
            loop: 1, // Loop the video
            playlist: videoId, // Required for looping
          },
          events: {
            onReady: (event) => {
              event.target.playVideo(); // Start video when player is ready
            },
            onStateChange: (event) => {
              console.log("Player state changed:", event.data);
            },
            onError: (event) => {
              console.error("Player error:", event.data);
            },
          },
        });
      }
    };

    // Load the YouTube IFrame API script
    const loadYouTubeAPI = () => {
      if (!window.YT) {
        const script = document.createElement("script");
        script.src = "https://www.youtube.com/iframe_api";
        script.onload = () => {
          // When script is loaded, initialize the player
          initializePlayer();
        };
        document.body.appendChild(script);
      } else {
        // API already loaded, initialize the player directly
        initializePlayer();
      }
    };

    loadYouTubeAPI();

    // Cleanup function to remove the script on component unmount
    return () => {
      const existingScript = document.querySelector(
        'script[src="https://www.youtube.com/iframe_api"]'
      );
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, [videoId]);

  return <div ref={playerRef}></div>;
};
*/

export default YouTubeVideo;
